import React  from 'react';
import cn from 'clsx';
import { Typography } from '../typography';
import { modalHeader, modalHeaderTitle, mobileHeaderTitle, mobileModalHeaderTitle } from './modal-styles';

type ModalHeaderProps = {
  className?: string;
  mobileTitle?: string;
  title: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ className, mobileTitle, title }) => (
  <div className={cn(modalHeader, className)}>
    <Typography className={cn(modalHeaderTitle, { [mobileHeaderTitle]: mobileTitle })} variant="h2" as="h2">{title}</Typography>
    {mobileTitle && (
      <Typography className={cn(modalHeaderTitle, { [mobileModalHeaderTitle]: mobileTitle })} variant="h2" as="h2">{mobileTitle}</Typography>
    )}
  </div>
);
